import React, { Component, Fragment } from 'react';
import {
  Container,
  Row, Col, Input, Button, Form, FormGroup
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import ConfirmButton from '../Modal/ConfirmButton';
class SalesOpportunitiesStages extends Component {

  standardRow = (stage) => {
    return (
      <Row className="adminRow pointer text-left" onClick={() => this.props.onEdit(stage.ID)}>
        <Col md={4}>{stage.Opportunity}</Col>
        <Col md={8}>{stage.Description}</Col>
      </Row>
    )
  }

  editRow = (stage) => {
    return (
      <Row className="editRow adminRow">
        <Col md={8} className="text-left">
          <Form inline>
            <FormGroup className="mr-2">
              <Input
                placeholder={this.props.label || 'Stage'}
                name="opportunity"
                value={this.props.editStage.opportunity + ''}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="mr-2">
              <Input
                placeholder="Description"
                name="description"
                value={this.props.editStage.description + ''}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
          </Form>
        </Col>
        <Col md={4} className="text-right">
          <Button className="mx-1" color="success" onClick={this.props.handleEdit} title={`Edit ${this.props.label || 'Stage'}`}>
            <FontAwesomeIcon icon={faCheck} />
          </Button>
          <ConfirmButton className="mx-3" color="danger" onClick={() => this.props.onDelete(stage.ID)} edit={`Delete ${this.props.label || 'Stage'}`}>
            <FontAwesomeIcon icon={faTrashAlt} />
          </ConfirmButton>
          <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Col>
      </Row>
    )
  }

  addRow = () => {
    return (<Row className="py-4 text-left align-items-bottom">
      <Col md={8}>
        <Form inline>
          <FormGroup className="mr-2">
            Add New {this.props.label || 'Stage'}
          </FormGroup>
          <FormGroup className="mr-2">
            <Input
              placeholder={this.props.label || 'Stage'}
              name="opportunity"
              value={this.props.newStage.opportunity + ''}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
          <FormGroup className="mr-2">
            <Input
              placeholder="Description"
              name="description"
              value={this.props.newStage.description + ''}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
        </Form>
      </Col>
      <Col md={4} className="text-right">
        <Button
          disabled={this.props.newStage.opportunity === '' || this.props.newStage.description === ''}
          color="primary"
          onClick={this.props.handleAdd}>
          Add {this.props.label || 'Stage'}
        </Button>
      </Col>
    </Row>
    )
  }

  render() {
    return (
      <Container className="adminContainer" fluid>
        {this.props.stages.map(stage => (
          <Fragment key={stage.ID}>{this.props.editStage.id === stage.ID ? this.editRow(stage) : this.standardRow(stage)}</Fragment>
        ))}
        {this.addRow()}
      </Container>
    );
  }
}

export default SalesOpportunitiesStages;
